<template>
  <v-container class="my-4">
    <v-card color="primary" class="fipa--header add-btn-wrap">
      <div class="ml-auto d-flex text-white">
        <div>
          <v-btn
            v-if="
              $allowedMutation(
                horse.allowedMutations,
                'horseApplicationPonyMeasurement'
              )
            "
            :to="{
              name: 'HorseApplicationPonyMeasurement',
              params: { horseId: horse.id }
            }"
            variant="text"
            size="small"
            class="btn-with-icon"
          >
            <div class="bg-edit btn-icon-with-text">
              <v-icon size="small" class="text-white">$iconPlus</v-icon>
            </div>
            <span class="text-white">
              {{
                $t(
                  "common:button.addPonyApplication",
                  "Add pony application",
                  "Add application button"
                )
              }}
            </span>
          </v-btn>
        </div>
        <div>
          <v-btn
            v-if="
              $allowedMutation(
                horse.allowedMutations,
                'horseAddPonyMeasurement'
              )
            "
            size="small"
            variant="text"
            class="btn-with-icon"
            data-test="horseAddMeasurement"
            @click="openForm({ horseId: horse.id })"
          >
            <div class="bg-edit btn-icon-with-text">
              <v-icon size="small" class="text-white">$iconPlus</v-icon>
            </div>
            <span class="text-white">
              {{ $t("common:button.add", "Add", "Add button") }}
            </span>
          </v-btn>
        </div>
      </div>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="ponyMeasurementsVisible"
      :hide-default-header="
        (ponyMeasurementsVisible && ponyMeasurementsVisible.length <= 0) ||
        $vuetify.display.smAndDown
      "
      disable-sort
      data-test="ponyMeasurement"
      class="entsys--table"
      hide-default-footer
    >
      <template #item="{ item, index, toggleExpand, internalItem, isExpanded }">
        <tr v-if="$vuetify.display.mdAndUp">
          <td>
            <v-icon
              v-if="item.comment"
              :aria-label="$t('common:commentIcon.alt')"
            >
              $iconCommentDots
            </v-icon>
          </td>
          <td>{{ $dayjs.date(item.measurementDate) }}</td>
          <td>{{ formatEffectivePeriod(item) }}</td>
          <td>
            {{ numberFormat(item.height) + " cm" }}
            {{ withWithoutShoes(item) }}
          </td>
          <td>{{ $t("horses:ponyTypes." + item.resultingType) }}</td>
          <td class="text-right px-0">
            <v-btn-icon
              v-if="
                $allowedMutation(
                  item.allowedMutations,
                  'horseUpdatePonyMeasurement'
                )
              "
              icon
              class="bg-edit-green"
              data-test="horseUpdatePonyMeasurement"
              size="small"
              :aria-label="$t('common:editButton.alt')"
              @click="openForm(item)"
            >
              <v-icon color="white" size="small"> $edit </v-icon>
            </v-btn-icon>
            <v-btn-icon
              v-if="canDelete(item)"
              icon
              class="bg-remove"
              data-test="horseDeleteMeasurement"
              size="small"
              :aria-label="$t('common:deleteButton.alt')"
              :loading="mutationId == `decline-${index}`"
              @click="deletePonyMeasurement(item, index)"
            >
              <v-icon color="white" size="small"> $iconTrash </v-icon>
              <template #loader>
                <v-progress-circular color="white" size="21" indeterminate />
              </template>
            </v-btn-icon>

            <v-btn-expand
              v-if="showAdditionals(item)"
              :model-value="isExpanded(internalItem)"
              data-test="expand"
              @click="toggleExpand(internalItem)"
            >
            </v-btn-expand>
          </td>
        </tr>
        <tr v-else>
          <td style="vertical-align: top">
            <template v-if="item.comment">
              <v-icon class="my-2" :aria-label="$t('common:commentIcon.alt')">
                $iconCommentDots
              </v-icon>
              <br />
            </template>
            <b>{{
              $t(
                "horses:horseProfilePage.PonyMeasurementSection.date.secondarytext",
                "Date",
                "text in pony measurement section"
              )
            }}</b>
            {{ $dayjs.date(item.measurementDate) }}
            <br />
            <b>{{
              $t(
                "horses:horseProfilePage.PonyMeasurementSection.effective.secondarytext",
                "Effective",
                "text in pony measurement section"
              )
            }}</b>
            {{ formatEffectivePeriod(item) }}
            <br />
            <b>{{
              $t(
                "horses:horseProfilePage.PonyMeasurementSection.height.secondarytext",
                "Height:",
                "text in pony measurement section"
              )
            }}</b>
            {{ numberFormat(item.height) + " cm" }} {{ withWithoutShoes(item) }}
            <br />
            <b>{{
              $t(
                "horses:horseProfilePage.PonyMeasurementSection.conclusion.secondarytext",
                "Conclusion",
                "text in pony measurement section"
              )
            }}</b>
            {{ $t("horses:ponyTypes." + item.resultingType) }}
          </td>
          <td>
            <div
              class="d-flex"
              style="flex-direction: column; align-items: end"
            >
              <v-btn-icon
                v-if="
                  $allowedMutation(
                    item.allowedMutations,
                    'horseUpdatePonyMeasurement'
                  )
                "
                icon
                class="bg-edit-green ma-2"
                data-test="horseUpdatePonyMeasurement"
                size="small"
                @click="openForm(item)"
              >
                <v-icon color="white" size="small"> $edit </v-icon>
              </v-btn-icon>

              <v-btn-icon
                v-if="canDelete(item)"
                icon
                :loading="mutationId == `decline-${index}`"
                size="small"
                class="bg-remove ma-2"
                @click="deletePonyMeasurement(item, index)"
              >
                <v-icon color="white" size="small"> $iconTrash </v-icon>
                <template #loader>
                  <v-progress-circular color="white" size="21" indeterminate />
                </template>
              </v-btn-icon>

              <v-btn-expand
                v-if="showAdditionals(item)"
                :model-value="isExpanded(internalItem)"
                class="ma-2"
                @click="toggleExpand(internalItem)"
              >
              </v-btn-expand>
            </div>
          </td>
        </tr>
      </template>
      <template #expanded-row="{ item }">
        <tr class="px-0">
          <template v-if="item.horseApplication">
            <td class="hidden-sm-and-down"></td>
            <td colspan="99">
              <PonyMeasurementDetails :item="item.horseApplication" />
            </td>
          </template>
          <template v-else-if="$vuetify.display.mdAndUp">
            <td></td>
            <td colspan="2">
              <template v-if="item.comment">
                <strong>{{
                  $t(
                    "horses:horseProfilePage.PonyMeasurementSection.comment.label",
                    "Comment",
                    "label pony measurement section"
                  )
                }}</strong>
                <br />
                {{ item.comment }}
              </template>
            </td>
            <td colspan="2">
              <div v-if="item.measurerPerson">
                <strong>{{
                  $t(
                    "horses:horseProfilePage.PonyMeasurementSection.measurerPersonId.label",
                    "Measurer person"
                  )
                }}</strong
                ><br />
                <AppShowPersonName :person="item.measurerPerson" />
              </div>
              <div v-if="item.veterinarianName">
                <strong>{{
                  $t(
                    "horses:horseProfilePage.PonyMeasurementSection.veterinarianName.label",
                    "Veterinarian name"
                  )
                }}</strong
                ><br />
                {{ item.veterinarianName }}
              </div>
            </td>
          </template>
          <td v-else colspan="99">
            <v-row no-gutters>
              <v-col cols="12">
                <template v-if="item.comment">
                  <strong>{{
                    $t(
                      "horses:horseProfilePage.PonyMeasurementSection.comment.label",
                      "Comment",
                      "label pony measurement section"
                    )
                  }}</strong>
                  <br />
                  {{ item.comment }}
                </template>
              </v-col>
              <v-col cols="12">
                <div v-if="item.measurerPerson">
                  <strong>{{
                    $t(
                      "horses:horseProfilePage.PonyMeasurementSection.measurerPersonId.label",
                      "Measurer person"
                    )
                  }}</strong
                  ><br />
                  <AppShowPersonName :person="item.measurerPerson" />
                </div>
                <div v-if="item.veterinarianName">
                  <strong>{{
                    $t(
                      "horses:horseProfilePage.PonyMeasurementSection.veterinarianName.label",
                      "Veterinarian name"
                    )
                  }}</strong
                  ><br />
                  {{ item.veterinarianName }}
                </div>
              </v-col>
            </v-row>
          </td>
        </tr>
      </template>
    </v-data-table>
    <HorsePonyMeasurementForm
      ref="form"
      @update="evt => $emit('update', evt)"
    />
  </v-container>
</template>
<script>
import { defineComponent } from "vue";
import { orderBy } from "lodash-es";
import gql from "fraql";
import numberFormat from "@/utils/numberFormat";
import PonyMeasurementDetails from "@/components/admin/HorseApplications/HorseApplicationDetails/PonyMeasurementDetails.vue";
import HorsePonyMeasurementForm from "./HorsePonyMeasurementForm.vue";
import AppShowPersonName from "@AppShows/person/AppShowPersonName.vue";

export default defineComponent({
  name: "HorsePonyMeasurementsSection",
  components: {
    PonyMeasurementDetails,
    HorsePonyMeasurementForm,
    AppShowPersonName
  },
  props: { horse: { type: Object, required: true } },
  emits: ["update"],
  data() {
    return {
      mutationId: null
    };
  },
  fragments: {
    horse: gql`
      fragment _ on Horse {
        ponyMeasurements {
          id
          horseId
          horseApplication {
            ${PonyMeasurementDetails.fragments.details}
          }
          ${HorsePonyMeasurementForm.fragments.ponyMeasurementFields}
          horseApplicationId
          withHorseshoe
          measurerPersonId
          measurerPerson {
            id
            ${AppShowPersonName.fragments.person}
          }
          veterinarianName
          measurementDate
          effectiveFromDate
          effectiveUntilDate
          height
          resultingType
          comment
          allowedMutations
        }
      }
    `
  },
  computed: {
    headers() {
      return [
        { value: "icon", title: "" },
        {
          value: "measurementDate",
          title: this.$t(
            "horses:horseProfilePage.PonyMeasurementSection.date.secondarytext",
            "Date",
            "text in pony measurement section"
          )
        },
        {
          value: "effective_date",
          title: this.$t(
            "horses:horseProfilePage.PonyMeasurementSection.effective.secondarytext",
            "Effective",
            "text in pony measurement section"
          )
        },
        {
          value: "height",
          title: this.$t(
            "horses:horseProfilePage.PonyMeasurementSection.height.label",
            "Height",
            "label pony measurement section"
          )
        },
        {
          value: "resultingType",
          title: this.$t(
            "horses:horseProfilePage.PonyMeasurementSection.conclusion.secondarytext",
            "Conclusion",
            "text in pony measurement section"
          )
        },
        { value: "", title: "" }
      ];
    },
    ponyMeasurementsVisible() {
      return orderBy(
        this.horse.ponyMeasurements.filter(Boolean),
        "measurementDate",
        "desc"
      );
    }
  },
  methods: {
    numberFormat,
    showAdditionals(item) {
      return Boolean(
        item.horseApplication ||
          item.comment ||
          item.veterinarianName ||
          item.measurerPerson
      );
    },
    withWithoutShoes(item) {
      return item.withHorseshoe
        ? `(${this.$t(
            "horses:horseProfilePage.PonyMeasurementSection.withShoes.label",
            "with shoes"
          )})`
        : `(${this.$t(
            "horses:horseProfilePage.PonyMeasurementSection.withoutShoes.label",
            "without shoes"
          )})`;
    },
    openForm(measurement) {
      this.$refs.form.openForm(measurement);
    },
    canDelete(item) {
      return this.$allowedMutation(
        item.allowedMutations,
        "horseDeletePonyMeasurement"
      );
    },
    formatEffectivePeriod(pony_measurement) {
      return (
        this.$dayjs.date(pony_measurement.effectiveFromDate) +
        " - " +
        (pony_measurement.effectiveUntilDate == "2299-12-31"
          ? "..."
          : this.$dayjs.date(pony_measurement.effectiveUntilDate))
      );
    },
    deletePonyMeasurement(item, index) {
      this.$root
        .$confirm(
          this.$t("horses:ponyMeasurement.deleteConfirm.heading"),
          this.$t("horses:ponyMeasurement.deleteConfirm.question")
        )
        .then(async confirm => {
          if (confirm) {
            this.mutationId = `decline-${index}`;
            this.$apollo
              .mutate({
                mutation: gql`
                  mutation horseDeletePonyMeasurement($id: ID!, $horseId: ID!) {
                    horseDeletePonyMeasurement(
                      input: { id: $id, horseId: $horseId }
                    ) {
                      horse {
                        id
                        ponyMeasurements {
                          id
                          measurementDate
                          height
                          comment
                          horseId
                          effectiveFromDate
                          effectiveUntilDate
                          isDeleted
                          resultingType
                          allowedMutations
                          horse {
                            id
                            horseType
                            ponyMeasurementEffectiveUntilDate
                          }
                        }
                      }
                    }
                  }
                `,
                variables: { id: item.id, horseId: this.horse.id }
              })
              .then(() => {
                // Result
                this.$root.$snackbar("success", {
                  text: this.$t(
                    "common:feedbackMessage.removedSuccessfully.text",
                    "Succesfully deleted!"
                  )
                });
                this.$emit("update", true);
                this.mutationId = null;
              })
              .catch(error => {
                // Error
                this.mutationId = null;
                this.$root.$snackbar("error", { text: error });
                throw error;
              });
          }
        });
    }
  }
});
</script>
